import React, { Component } from 'react';
import { Modal } from 'antd';
import DrawerHeader from '../Drawer/DrawerHeader';
import { FlexContainer } from '../../layouts/Wrapper/Base.components';
import { any, string, func, bool, number } from 'prop-types';
import { isFunction } from 'lodash';

class BackOfficeModal extends Component {
    static propTypes = {
        children: any.isRequired,
        title: string,
        onClose: func,
        visible: bool,
        width: number,
        render: func,
        withoutHeader: bool
    }

    static defaultProps = {
        title: 'BackOffice Modal',
        onClose: () => {},
        visible: false,
        width: 600,
        withoutHeader: false
    }

    _render () {
        const { render, children } = this.props;
        return isFunction(render) ? render(this.props) : children;
    }
    render () {
        const { title, onClose, visible, width, withoutHeader } = this.props;
        return (
            <Modal
                visible={visible}
                footer={null}
                closable={false}
                onCancel={onClose}
                width={width}
                destroyOnClose
            >
                <FlexContainer padding='15' margin='-24' direction='column' style={{ minHeight: 200 }}>
                    { !withoutHeader && <DrawerHeader title={title} style={{ width: 'auto', margin: '-15px', padding: '15px', borderBottom: 0 }} onClose={onClose} /> }
                    <FlexContainer mT={25} direction='column'>
                        { this._render() }
                    </FlexContainer>
                </FlexContainer>
            </Modal>
        );
    }
}

export default BackOfficeModal;
